export default {
  terms: {
    title: "Términos y condiciones",
  },
  privacy: {
    title: "Avisos de privacidad",
  },
}
